export enum Features {
    ContentIsUpToDate = 1,
    CountryComparison = 2,
    AboutUs = 3,
    PdfDownload = 4,
    AuditHistory = 5,
    Timeline = 6,
    PublishedDate = 7,
    EmailNotification = 8,
    EmailDigest = 9
}